import { FC } from "react";
import { Link } from "react-router-dom";
import { Anchor, Stack, Text, Title } from "@mantine/core";
import { ForgotPasswordForm } from "../../features/forgot-password/ForgotPasswordForm";
import { useTranslation } from "react-i18next";

interface Props {
  onContinue: () => void;
}

export const ForgotPasswordWidget: FC<Props> = ({ onContinue }) => {
  const { t } = useTranslation();

  return (
    <Stack align="stretch" justify="center" gap="24px">
      <Title size={36}>{t("reset_password_title")}</Title>
      <Text c="dimmed" size="md">
        {t("reset_password_description")}
      </Text>
      <ForgotPasswordForm onContinue={onContinue} />
      <Anchor
        c="dimmed"
        to="/login/sign-in"
        underline="always"
        component={Link}
      >
        {t("back_to_sign_in")}
      </Anchor>
    </Stack>
  );
};
